import { HOME_BODY_COLOR } from "styles/oneOffColor";

const styles = {
  iconBlock: {
    fontSize: 20,
    backgroundColor: HOME_BODY_COLOR,
    borderRadius: 2,
    width: 35,
    height: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    p: 1,
    mr: 3,
  },
};

export default styles;
